import i18n from '@/lang';

// 导出状态
export const STATUS = Object.freeze({
  '0': {
    label: i18n.t('basicData.queuing'), // 排队中
    type: 'primary',
    value: 0
  },
  '1': {
    label: i18n.t('basicData.exporting'), // 导出中
    type: 'warning',
    value: 1
  },
  '2': {
    label: i18n.t('basicData.success'), // 成功
    type: 'success',
    value: 2
  },
  '3': {
    label: i18n.t('basicData.failed'), // 失败
    type: 'danger',
    value: 3
  },
  '4': {
    label: i18n.t('basicData.cancelled'), // 取消
    type: 'info',
    value: 4
  }
});

// 模块
export const MODULE = Object.freeze({
  // 'BASIC_INFO': i18n.t('RouterObj.BasicInformation'), // 基础资料
  // 'RECEIVABLE': i18n.t('RouterObj.ReceivableManagementSite'), // 应收
  // 'PAYABLE': i18n.t('RouterObj.PayableManagement'), // 应付
  // 'REPORT': i18n.t('RouterObj.ReportDashboard') // 报表

  'BASIC_INFO': {
    label: i18n.t('RouterObj.BasicInformation'), // 基础资料
    value: 'BASIC_INFO'
  },
  'RECEIVABLE': {
    label: i18n.t('RouterObj.ReceivableManagementSite'), // 应收
    value: 'RECEIVABLE'
  },
  'PAYABLE': {
    label: i18n.t('RouterObj.PayableManagement'), // 应付
    value: 'PAYABLE'
  },
  'REPORT': {
    label: i18n.t('RouterObj.ReportDashboard'), // 报表
    value: 'REPORT'
  }
});
